import React, { useState } from 'react';

const Fracht = () => {
  const [form, setForm] = useState({
    title: '',
    gewicht: '',
    von: '',
    nach: '',
    image: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setForm({ ...form, image: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Fracht "${form.title}" wurde eingetragen!`);
    // später: fetch() ans Backend
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Fracht einstellen</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Titel der Fracht"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="gewicht"
          value={form.gewicht}
          onChange={handleChange}
          placeholder="Gewicht (z.B. 1.200 kg)"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="von"
          value={form.von}
          onChange={handleChange}
          placeholder="Von"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="nach"
          value={form.nach}
          onChange={handleChange}
          placeholder="Nach"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleChange}
          className="block w-full text-sm text-slate-500
            file:mr-4 file:py-2 file:px-4
            file:rounded-lg file:border-0
            file:bg-blue-50 file:text-blue-700 dark:file:bg-zinc-700 dark:file:text-blue-400"
        />

        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-bold transition"
        >
          Fracht eintragen
        </button>
      </form>
    </div>
  );
};

export default Fracht;
